import React, { useMemo, useRef, useEffect } from "react";
import Heading from "@druva-apps/orion/lib/heading";
import Input from "@druva-apps/orion/lib/input";
import Form from "@druva-apps/orion/lib/form";
import FormGroup from "@druva-apps/orion/lib/formGroup";
import Button from "@druva-apps/orion/lib/button";

import BackButton from "../BackButton";
import FormCardBody from "../FormCardBody";
import styles from "../FormContainer.module.scss";

const PasswordSchemaCreator = (Yup) =>
  Yup.object().shape({
    password: Yup.string().required("Required"),
  });

const PasswordForm = ({
  setStep,
  initialValue,
  onSubmit,
  email,
  onForgotPassword,
  isForgotPasswordLoading,
}) => {
  const initialValues = useMemo(
    () => ({ password: initialValue }),
    [initialValue]
  );
  const passwordInputRef = useRef();

  useEffect(() => {
    passwordInputRef.current.focus();
  }, []);
  return (
    <FormCardBody
      footer={
        <BackButton
          dataTestId="login-pw-back-btn"
          onClick={() => {
            setStep(0);
          }}
          label="Back"
        />
      }
    >
      <Heading
        type="4"
        text="Login to your account"
        className="oui-font-weight-normal oui-mt-2 oui-mb-4 oui-text-center"
        dataTestId="login-pw-lbl"
      />
      <Form
        validationSchema={PasswordSchemaCreator}
        withValidation
        initialValues={initialValues}
        onSubmit={onSubmit}
        className={styles.formContainer}
        renderChildren={(props) => (
          <>
            <div className="oui-mb-4 oui-pt-2 oui-ml-2">{email}</div>
            <div className="oui-mb-4">
              <FormGroup className={`${styles.input} oui-mb-0`}>
                <Input
                  data-testid="login-pw-passwd-txt"
                  innerRef={passwordInputRef}
                  type="password"
                  name="password"
                  placeholder="Enter Password"
                  validationProps={props}
                  isInvalid={
                    props.touched.password &&
                    props.errors.password !== undefined
                  }
                  autoComplete="off"
                />
              </FormGroup>
              {typeof onForgotPassword === "function" && (
                <div className="oui-text-right oui-mt-0">
                  <Button
                    type="link"
                    label="Forgot Password ?"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onForgotPassword();
                    }}
                    disabled={isForgotPasswordLoading}
                    dataTestId="login-pw-forgot-btn"
                    size="sm"
                    className="oui-text-decoration-none oui-p-0"
                  />
                </div>
              )}
            </div>
            <Button
              label="Submit"
              dataTestId="login-pw-submit-btn"
              size="lg"
              block
              type="primary"
              onClick={props.submitForm}
              className="oui-mb-4"
              disabled={!props.isValid}
            />
          </>
        )}
      />
    </FormCardBody>
  );
};

export default PasswordForm;
